// default type is home
// option for type is home, mailing, billing
export const getMemberAddressByType = (userDetails, addressType = 'home') => {
  return {
    address1: userDetails?.[`${addressType}_address1`],
    address2: userDetails?.[`${addressType}_address2`],
    city: userDetails?.[`${addressType}_city`],
    state: userDetails?.[`${addressType}_state`],
    zipCode: userDetails?.[`${addressType}_zip`],
  }
}
